
import { Vue, Component, Ref } from 'vue-property-decorator';
import { FormModel } from 'ant-design-vue';
import lazyInject from '@/di';
import SupplyService from '@/services/supply.service';

@Component
export default class GoodsModal extends Vue {
  visible = false;

  isEdit = false;

  @lazyInject(SupplyService)
  supplyService!: SupplyService;

  record: any = null;

  cateConfig: any = [];

  form: any = {
    commodity_code: '',
    name: '',
    pid: '1',
    category_id: '2',
  };

  rules: any = {
    commodity_code: [
      { required: true, message: '请输入物料编码', trigger: 'blur' },
    ],
    name: [{ required: true, message: '请输入商品名称', trigger: 'blur' }],
  };

  @Ref('ruleForm')
  private ruleForm!: FormModel;

  open(record?: any) {
    this.isEdit = !!record;
    this.record = record || null;
    this.$nextTick(() => {
      this.ruleForm && this.ruleForm.clearValidate('');
    });
    if (this.isEdit) {
      this.getDetail();
    } else {
      this.form = {
        commodity_code: '',
        name: '',
        pid: '1',
        category_id: '2',
      };
      this.getConfig();
    }
  }

  async getDetail() {
    const res = await this.supplyService.getCommodityDetail({
      id: this.record.id,
    });
    const { detail, cateConfig } = res;
    this.cateConfig = cateConfig?.attributes || [];
    // 根据 attributes 动态初始化 form 字段和校验规则
    const form: any = {
      commodity_code: detail?.commodity_code || '',
      name: detail?.name || '',
      pid: detail?.pid || '',
      id: detail?.id || '',
      category_id: detail?.category_id || '',
      status: detail?.status ?? 1,
      ...(detail?.product_attributes || {}),
    };
    const rules: any = {};
    // 收集需要请求选项的子属性（parent_attr_id > 0）
    const childAttrs = this.cateConfig.filter(
      (attr: any) => attr.parent_attr_id > 0,
    );
    this.cateConfig.forEach((attr: any) => {
      // 根据 field_type 初始化表单字段
      if (attr.field_type === 3) {
        if (!(attr.code in form)) {
          this.$set(form, attr.code, []);
        }
      } else if (attr.field_type === 5) {
        if (!(`${attr.code }_min` in form)) {
          this.$set(form, `${attr.code }_min`, undefined);
          this.$set(form, `${attr.code }_max`, undefined);
        }
      } else if (attr.field_type === 7 || attr.field_type === 8) {
        if (!(attr.code in form)) {
          this.$set(form, attr.code, []);
        }
      } else if (!(attr.code in form)) {
        this.$set(form, attr.code, '');
      }
      // 根据 is_required 生成校验规则
      if (attr.is_required === 1) {
        const isSelect = [2, 3, 6, 7, 8].includes(attr.field_type);
        rules[attr.code] = [
          {
            required: true,
            message: `${isSelect ? '请选择' : '请输入'}${attr.label}`,
            trigger: 'change',
          },
        ];
      }
    });
    this.form = { ...this.form, ...form };
    this.rules = { ...this.rules, ...rules };
    await Promise.all(
      childAttrs.map(async (child: any) => {
        try {
          const optRes = await this.supplyService.getCommodityCateOptions({
            source_attr_id: child.parent_attr_id,
            source_value_id: child.parent_attr_id,
            target_attr_id: child.id,
          });
          const options = optRes?.options || optRes?.data?.options || [];
          const target = this.cateConfig.find((a: any) => a.id === child.id);
          if (target) {
            this.$set(target, 'options', options);
          }
        } catch (e) {
          // ignore
        }
      }),
    );
    this.visible = true;
  }
  async getConfig() {
    const res = await this.supplyService.getCommodityCateConfig({
      category_id: 1,
    });
    this.cateConfig = res.attributes || [];
    // 根据 attributes 动态初始化 form 字段和校验规则
    const form: any = { ...this.form };
    const rules: any = {};
    // 收集需要请求选项的子属性（parent_attr_id > 0）
    const childAttrs = this.cateConfig.filter(
      (attr: any) => attr.parent_attr_id > 0,
    );
    this.cateConfig.forEach((attr: any) => {
      // 根据 field_type 初始化表单字段
      if (attr.field_type === 3) {
        if (!(attr.code in form)) {
          this.$set(form, attr.code, []);
        }
      } else if (attr.field_type === 5) {
        if (!(`${attr.code }_min` in form)) {
          this.$set(form, `${attr.code }_min`, undefined);
          this.$set(form, `${attr.code }_max`, undefined);
        }
      } else if (attr.field_type === 7 || attr.field_type === 8) {
        if (!(attr.code in form)) {
          this.$set(form, attr.code, []);
        }
      } else if (!(attr.code in form)) {
        this.$set(form, attr.code, '');
      }
      // 生成校验规则
      if (attr.is_required === 1) {
        const isSelect = [2, 3, 6, 7, 8].includes(attr.field_type);
        rules[attr.code] = [
          {
            required: true,
            message: `${isSelect ? '请选择' : '请输入'}${attr.label}`,
            trigger: 'change',
          },
        ];
      }
    });
    this.form = { ...this.form, ...form };
    this.rules = { ...this.rules, ...rules };
    await Promise.all(
      childAttrs.map(async (child: any) => {
        try {
          const optRes = await this.supplyService.getCommodityCateOptions({
            source_attr_id: child.parent_attr_id,
            source_value_id: child.parent_attr_id,
            target_attr_id: child.id,
          });
          const options = optRes?.options || optRes?.data?.options || [];
          const target = this.cateConfig.find((a: any) => a.id === child.id);
          if (target) {
            this.$set(target, 'options', options);
          }
        } catch (e) {
          // ignore
        }
      }),
    );
    this.visible = true;
  }

  handleOk() {
    this.ruleForm.validate(async (valid) => {
      if (!valid) {
        return false;
      }
      if (this.isEdit) {
        const res = await this.supplyService.postCommodityEdit(this.form);
        if (res) {
          this.$message.success('编辑成功');
          this.visible = false;
          this.$emit('refresh');
        }
      } else {
        const res = await this.supplyService.postCommodityEdit(this.form);
        if (res) {
          this.$message.success('新增成功');
          this.visible = false;
          this.$emit('refresh');
        }
      }
    });
  }

  handleCancel() {
    this.visible = false;
    this.ruleForm.resetFields();
  }

  /** 将 options 的 code 映射为 cascader 需要的 value */
  mapCascaderOptions(opts: any[]): any[] {
    return (opts || []).map((opt: any) => ({
      value: opt.code,
      label: opt.label,
    }));
  }
}
